import {
    GET_FORECASTING,
} from "@actions/inventory/forecasting/types";

import {
    ForecastingState,
    ForecastingStateAction
} from "@reducers/types/inventory/forecasting-state";

export const initialState: ForecastingState = {
    isGetLoading: false,
    isUpdateLoading: false,
    isDeleteLoading: false,
    isCreateLoading: false,

    getError: null,
    createError: null,
    updateError: null,
    deleteError: null,

    getSuccess: false,
    createSuccess: false,
    updateSuccess: false,
    deleteSuccess: false,

    getData: null,
};

const forecastingReducer = (state: ForecastingState = initialState,
    action: ForecastingStateAction): ForecastingState => {

    const { type, payload } = action;

    switch (type) {
        // fetch
        case GET_FORECASTING.LOADING:
            return {
                ...state,
                isGetLoading: payload,
                createSuccess: false,
                deleteSuccess: false,
            };

        case GET_FORECASTING.SUCCESS:
            return {
                ...state,
                getError: null,
                getData: payload,
                isGetLoading: false,
            };

        case GET_FORECASTING.ERROR:
            return {
                ...state,
                getError: payload,
                getData: null,
                isGetLoading: false,
            };

        default:
            return state;
    }
}

export default forecastingReducer